module.exports = __webpack_public_path__ + "img/top BT (4).ef5a6401.png";